// Custom code: unselect

document.addEventListener('DOMContentLoaded', function() {
  var addToCartButton = document.querySelector('.product-section[data-modal="false"] [data-add-to-cart]');

  if (!addToCartButton) {
    return;
  }

  addToCartButton.addEventListener('click', function(event) {
    var variantRadios = document.querySelectorAll('.product-section[data-modal="false"] select[data-variant-input]');
    for (const variantSelect of [...variantRadios]) {
      var selectedVariant = variantSelect.options[variantSelect.selectedIndex];
  
      if (!selectedVariant.value) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
        alert('Please select a variant before adding to cart.');
        return
      }
    }

    var variantRadios = document.querySelectorAll('.product-section[data-modal="false"] input[type="radio"][data-variant-input]');
    for (const variantRadio of [...variantRadios]) {
        if (variantRadio.checked && variantRadio.value === '') {
          event.stopPropagation();
          event.stopImmediatePropagation();
          event.preventDefault();
          alert('Please select a variant before adding to cart.');
          return
        }
    }
  }, true);
});
